var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpisodeEnded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ended Episode") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ended-Episode",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.500000, 2.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.984,24 L2.016,24 C0.904,24 0,23.096 0,21.984 L0,2.016 C0,0.904 0.904,9.09494702e-13 2.016,9.09494702e-13 L21.985,9.09494702e-13 C23.096,9.09494702e-13 24,0.904 24,2.016 L24,21.985 C24,23.096 23.096,24 21.984,24 Z M2.016,1 C1.456,1 1,1.456 1,2.016 L1,21.985 C1,22.544 1.456,23 2.016,23 L21.985,23 C22.544,23 23,22.544 23,21.984 L23,2.016 C23,1.456 22.544,1 21.984,1 L2.016,1 Z",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,6.5 L5,6.5 C4.724,6.5 4.5,6.276 4.5,6 C4.5,5.724 4.724,5.5 5,5.5 L7,5.5 C7.276,5.5 7.5,5.724 7.5,6 C7.5,6.276 7.276,6.5 7,6.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,10.5 L5,10.5 C4.724,10.5 4.5,10.276 4.5,10 C4.5,9.724 4.724,9.5 5,9.5 L7,9.5 C7.276,9.5 7.5,9.724 7.5,10 C7.5,10.276 7.276,10.5 7,10.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,14.5 L5,14.5 C4.724,14.5 4.5,14.276 4.5,14 C4.5,13.724 4.724,13.5 5,13.5 L7,13.5 C7.276,13.5 7.5,13.724 7.5,14 C7.5,14.276 7.276,14.5 7,14.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,18.5 L5,18.5 C4.724,18.5 4.5,18.276 4.5,18 C4.5,17.724 4.724,17.5 5,17.5 L7,17.5 C7.276,17.5 7.5,17.724 7.5,18 C7.5,18.276 7.276,18.5 7,18.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,6.5 L11,6.5 C10.724,6.5 10.5,6.276 10.5,6 C10.5,5.724 10.724,5.5 11,5.5 L19,5.5 C19.276,5.5 19.5,5.724 19.5,6 C19.5,6.276 19.276,6.5 19,6.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,10.5 L11,10.5 C10.724,10.5 10.5,10.276 10.5,10 C10.5,9.724 10.724,9.5 11,9.5 L19,9.5 C19.276,9.5 19.5,9.724 19.5,10 C19.5,10.276 19.276,10.5 19,10.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,14.5 L11,14.5 C10.724,14.5 10.5,14.276 10.5,14 C10.5,13.724 10.724,13.5 11,13.5 L19,13.5 C19.276,13.5 19.5,13.724 19.5,14 C19.5,14.276 19.276,14.5 19,14.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,18.5 L11,18.5 C10.724,18.5 10.5,18.276 10.5,18 C10.5,17.724 10.724,17.5 11,17.5 L19,17.5 C19.276,17.5 19.5,17.724 19.5,18 C19.5,18.276 19.276,18.5 19,18.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6926141,9.60233274 C26.4110868,9.60233274 27.1295595,9.87642084 27.6777357,10.424597 C28.2259119,10.9727732 28.5,11.6912459 28.5,12.4097186 C28.5,13.1281913 28.2259119,13.846664 27.6778394,14.3947366 L27.6778394,14.3947366 L14.5570744,27.5180661 C13.8227432,28.2867031 13.1860546,28.4669045 12.5742001,28.4980592 C11.4918969,28.4667706 10.8988283,28.1553708 10.4209034,27.6774421 L10.4209034,27.6774421 L4.31339994,21.5469325 C3.76522375,20.9987563 3.49113565,20.2802836 3.49113565,19.5618109 C3.49113565,18.8433382 3.76522375,18.1248655 4.31339994,17.5766893 C4.86157613,17.0285131 5.58004883,16.754425 6.29852153,16.754425 C7.01699424,16.754425 7.73546694,17.0285131 8.28362584,17.576672 L8.28362584,17.576672 L12.4191588,21.7120701 L23.7074925,10.424597 C24.2556687,9.87642084 24.9741414,9.60233274 25.6926141,9.60233274 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpisodeEnded);
export default __webpack_public_path__ + "static/media/episode-ended.0d7844834b7e48bf5feeb7b620ee55ea.svg";
export { ForwardRef as ReactComponent };